import React, { Component } from 'react';
import { Message } from 'semantic-ui-react';

export default class FileSpecs extends Component {
  state = {
    show: false,
  };

  onViewClick = () => {
    this.setState({
      show: !this.state.show,
    });
  };

  render() {
    return (
      <div className={'file-specs'}>
        <a onClick={this.onViewClick} style={{ cursor: 'pointer' }}>
          View file specifications
        </a>
        {this.state.show && (
          <Message>
            <Message.Header>File layout specifications</Message.Header>
            <Message.List>
              <Message.Item>Max file size (1MB)</Message.Item>
              <Message.Item>
                .csv (comma) with optional text qualifiers
              </Message.Item>
            </Message.List>
            <Message.Header>Required fields</Message.Header>
            <Message.List>
              <Message.Item>ID (School Id, max. 8 characters)</Message.Item>
              <Message.Item>
                Description (School description, max. 30 characters)
              </Message.Item>
            </Message.List>
            <Message.Header>Optional fields</Message.Header>
            <Message.List>
              <Message.Item>SiteGroupId (integer)</Message.Item>
              <Message.Item>ShipAddress1 (max. 30 characters)</Message.Item>
              <Message.Item>ShipAddress2 (max. 30 characters)</Message.Item>
              <Message.Item>
                City (combination of City, State and Zip, max. 30 characters)
              </Message.Item>
              <Message.Item>State</Message.Item>
              <Message.Item>Zip</Message.Item>
              <Message.Item>ShipAttention</Message.Item>
              <Message.Item>ManagersEmailId (max. 50 characters) </Message.Item>
            </Message.List>
            <Message.Header>
              Sample File with only the required fields
            </Message.Header>
            <Message.List>
              <Message.Item>
                Id, Description, SiteGroupId, ShipAddress1, ShipAddress2, City,
                State,Zip, ShipAttention, ManagersEmailId
              </Message.Item>
              <Message.Item>411,MISC HIGH SCHOOL,,,,,,,,</Message.Item>
            </Message.List>
            <Message.Header>Sample File</Message.Header>
            <Message.List>
              <Message.Item>
                Id, Description, SiteGroupId, ShipAddress1, ShipAddress2, City,
                State,Zip, ShipAttention, ManagersEmailId
              </Message.Item>
              <Message.Item>
                411,MISC HIGH SCHOOL,,2222 Main St,,Wilmington,NC,28403,"Manager
                Name, Jr.",managereamil@domain.com
              </Message.Item>
            </Message.List>
          </Message>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/importsite/components/FileSpecs.js